export class ChampLibre {
  libelle: string;
  value?: number | string;
  date?: Date | string;

  constructor(
    libelle: string,
    value?: number | string,
    date?: Date | string,
  ) {
    this.libelle = libelle;
    this.value = value;
    this.date = date;
  }

  static factory(champLibreAPI: ChampLibreAPI): ChampLibre {
    const dataDate = champLibreAPI.Date?.split('-');

    return new ChampLibre(
      champLibreAPI.Libelle ? champLibreAPI.Libelle : champLibreAPI.ChampLibelle ? champLibreAPI.ChampLibelle : '',
      !isNaN(Number(champLibreAPI.Valeur))
        ? Number(champLibreAPI.Valeur)
        : !isNaN(Number(champLibreAPI.Valeur.replace(',', '.')))
          ? Number(champLibreAPI.Valeur.replace(',', '.'))
          : champLibreAPI.Valeur == ''
            ? undefined
            : champLibreAPI.Valeur,
      dataDate && dataDate.length == 3
        ? new Date(
          dataDate[2].toString() +
          '-' +
          dataDate[1].toString() +
          '-' +
          dataDate[0].toString()
        )
        : undefined
    );
  }
}

export type ChampLibreAPI = {
  Libelle?: string;
  ChampLibelle?: string;
  Valeur: string;
  Date?: string;
};
